import { Companion_getInstance1tv6fqjnytc8u as Companion_getInstance } from '../type/GraphQLBoolean.mjs';
import {
  Builder320ghmibyd2no as Builder,
  Builder3t31vflw4km89 as Builder_0,
  CompiledVariablecaz6ndkw7us2 as CompiledVariable,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { Companion_getInstanceoymipm3rjnhd as Companion_getInstance_0 } from '../type/Mutation.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DeleteSecretMutationSelectionsClass;
function DeleteSecretMutationSelections() {
  if (DeleteSecretMutationSelectionsClass === VOID) {
    class $ {
      constructor() {
        DeleteSecretMutationSelections_instance = this;
        this.n6j_1 = listOf((new (Builder())('deleteSecret', Companion_getInstance().p6s_1)).o46(listOf((new (Builder_0())(Companion_getInstance_0().x6g_1)).z46(new (CompiledVariable())('input')).e3a())).e3a());
      }
    }
    initMetadataForObject($, 'DeleteSecretMutationSelections');
    DeleteSecretMutationSelectionsClass = $;
  }
  return DeleteSecretMutationSelectionsClass;
}
var DeleteSecretMutationSelections_instance;
function DeleteSecretMutationSelections_getInstance() {
  if (DeleteSecretMutationSelections_instance === VOID)
    new (DeleteSecretMutationSelections())();
  return DeleteSecretMutationSelections_instance;
}
//region block: exports
export {
  DeleteSecretMutationSelections_getInstance as DeleteSecretMutationSelections_getInstance1gjquo03jqhml,
};
//endregion

//# sourceMappingURL=DeleteSecretMutationSelections.mjs.map
